import { render } from "./product-price-group-list.vue?vue&type=template&id=41537bc4"
import script from "./product-price-group-list.vue?vue&type=script&lang=js"
export * from "./product-price-group-list.vue?vue&type=script&lang=js"

import "./product-price-group-list.vue?vue&type=style&index=0&id=41537bc4&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__